export const colorThemes = ["system", "light", "dark"];
